import PropTypes from 'prop-types';

const propType = {
  termsAndConditions: PropTypes.string,
  privacyPolicy: PropTypes.string,
  documentTypes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  cryptoCurrencies: PropTypes.arrayOf(PropTypes.string),
};

export default { propType };
